import { render, staticRenderFns } from "./evaluationQuestion.vue?vue&type=template&id=a50390b4&scoped=true"
import script from "./evaluationQuestion.vue?vue&type=script&lang=js"
export * from "./evaluationQuestion.vue?vue&type=script&lang=js"
import style0 from "./evaluationQuestion.vue?vue&type=style&index=0&id=a50390b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50390b4",
  null
  
)

export default component.exports